import type { FileIconProps } from './FileIcon';

function FileNotaryIcon({ extension, color, size = 28, ...props }: FileIconProps) {
  return (
    <svg width={size} height={size * 1.25} viewBox='0 0 28 35' fill='none' {...props}>
      <path d='M4 35h20a4 4 0 004-4V10L18 0H4a4 4 0 00-4 4v27a4 4 0 004 4z' fill={color} />
      <path opacity={0.4} d='M18 10V0l10 10H18z' fill='#fff' />
      <path
        d='M9.667 14.833h9.166M13 18.167h9.167m-15 3.333h9.166m-12.5 3.333H13'
        stroke='url(#prefix__paint0_linear)'
        strokeWidth={2}
        opacity={0.4}
      />
      <text fill='#fff' x='50%' y='90%' textAnchor='middle' fontSize={9} fontWeight='bold'>
        {extension?.toUpperCase()}
      </text>
      <defs>
        <linearGradient
          id='prefix__paint0_linear'
          x1={13}
          y1={14.833}
          x2={13}
          y2={33}
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#fff' />
          <stop offset={1} stopColor='#fff' stopOpacity={0} />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default FileNotaryIcon;
